<app-custom-modal customTitle="¿Qué quieres hacer?" maxWidth="md" [hideFooter]="true"
  (closeFunction)="closeFunction.emit()">

  <div class="flex flex-col gap-4">
    <div class="flex flex-col gap-1">
      <label class="text-xs font-bold text-slate-500 uppercase tracking-wider">Fecha del documento</label>
      <input type="date" [(ngModel)]="date"
        class="w-full px-3 py-2 border border-slate-200 rounded-xl text-sm font-bold text-slate-700 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-400 outline-none transition-all">
    </div>

    <div class="flex gap-3">
      <button type="button" (click)="accept('factura')"
        class="flex-1 cursor-pointer py-3 bg-blue-600 text-white hover:bg-blue-500 rounded-xl font-bold text-sm tracking-wider transition-all uppercase shadow-lg shadow-blue-900/20">
        Factura
      </button>
      <button type="button" (click)="accept('albaran')"
        class="flex-1 cursor-pointer py-3 bg-emerald-600 text-white hover:bg-emerald-500 rounded-xl font-bold text-sm tracking-wider transition-all uppercase shadow-lg shadow-emerald-900/20">
        Albarán
      </button>
      <button type="button" (click)="accept('devolucion')"
        class="flex-1 cursor-pointer py-3 bg-red-600 text-white hover:bg-red-500 rounded-xl font-bold text-sm tracking-wider transition-all uppercase shadow-lg shadow-red-900/20">
        Devolución
      </button>
    </div>
  </div>

</app-custom-modal>
